
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Situacion } from '@/__env/lib/Pantalla/Situacion';
    import { Empresa } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
    import moment from 'moment';
    import { EstadisticaVentas, Cliente } from '@/__env/lib/Clientes';
    import { WaitEntre } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public Estado: 'ok' | 'cargando' = 'cargando';

        @Prop( { type: Cliente } )
        public Cliente: Cliente;
        @Watch( 'Cliente', { immediate: true } )
        onEmpresa()
        {
            this.buscar();
        }

        public Item: EstadisticaVentas = new EstadisticaVentas();
        async buscar()
        {
            await WaitEntre( 1000, 2000 );
            this.Item = await EstadisticaVentas.actual( this.Cliente );
            this.Estado = 'ok';
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {

            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {

        }

        public Seleccionar( x: Cliente )
        {
            this.Controlador.ClienteSeleccionado = x;
            this.Controlador.Vista.Modo = 'cliente';
        }
    }
